<div class="bg-gray-50 rounded-medium p-8 shadow-[0_4px_18px_0_rgba(0,0,0,0.17)] md:w-[660px] md:h-[710px]" *transloco="let t; prefix: 'property-listing.photos.photo-tag-modal'">
  <div class="flex flex-col text-center">
      <div class="flex flex-col gap-2">
        <div class="flex justify-end">
            <button class="p-2" (click)="close()"><i class="icon-close text-xl"></i></button>
        </div>
        <div class="flex flex-col gap-7">
            <h2 class="text-4xl text-black">Η υπηρεσία θα είναι <span class="text-primary-700">σύντομα</span> κοντά σου</h2>
            <h4 class="text-lg text-gray-900">Η υπηρεσία αυτή βρίσκεται καθ' οδόν και θα είναι διαθέσιμη σύντομα. Δουλεύουμε σκληρά για να σου προσφέρουμε κάτι καταπληκτικό.</h4>
        </div>

        <img src="../../../../assets/img/services/unavailable-service.png" alt="unavalable service" class="w-[290px] h-full self-center mt-14">
      </div>
  </div>
</div>
